// extracted by mini-css-extract-plugin
export default {"openForm":"CbPerpeptual_openForm__x4RjF"};